export default "__VITE_ASSET__DuXlDMj1__"